import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { Table } from 'ksnm-common-ui/lib/Table2';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';
import type { Filter } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { getExcelWithAudit } from '@src/utils/getExcelWithAudit';
import { useTableTitleWithCount } from '@src/utils/hooks/useTableTitleWithCount';
import { auditStore } from '@stores/auditStore';
import { constantStore } from '@stores/constantStore';
import { ksnmTableStore } from '@stores/ksnmTableStore/ksnmTableStore';
import { reportingFormFiveStore } from '@stores/reportingFormFiveStore';
import { reportingFormsStore } from '@stores/reportingFormsStore';

import { generateColumns } from './columns';

interface ExtendColumnInterface {
  columns: ColumnInterface[];
  resource: string;
}

const { TABLE_NAMES } = constantStore;

export const ReportingFormFive = observer(() => {
  const [columns5level, setColumns5level] = useState<ExtendColumnInterface>({ columns: [], resource: '' });

  const { lastPagesParam, pagesParam } = reportingFormsStore;
  const { getColumns } = reportingFormFiveStore;

  const {
    reportPackageCode = '',
    reportVersionCode = '',
    reportSettingsTableSource = '',
    reportSettingsUITableSource = '',
    reportFilters = [],
  } = lastPagesParam;

  useEffect(() => {
    auditStore.createAuditData({
      moduleName: 'Calculator',
      serviceName: 'Reporting_structure',
      operationName: 'View_reporting',
      message: `Просмотр отчёта ${pagesParam.at(-1)?.title ?? ''}. Пакет ${reportPackageCode}.`,
    });
  }, [pagesParam, reportPackageCode]);

  useEffect(
    () => () => {
      setColumns5level({ columns: [], resource: '' });
    },
    [getColumns],
  );

  useEffect(() => {
    (async () => {
      const result = await getColumns(reportSettingsUITableSource || reportSettingsTableSource);

      setColumns5level({
        columns: generateColumns(result.columns),
        resource: reportSettingsUITableSource || reportSettingsTableSource,
      });
    })();
  }, [
    getColumns,
    lastPagesParam,
    reportPackageCode,
    reportSettingsTableSource,
    reportSettingsUITableSource,
    reportVersionCode,
  ]);

  const TABLE_NAME = useMemo(
    () => `${TABLE_NAMES.REPORTING_FORM_FIVE}_${reportPackageCode}_${reportVersionCode}`,
    [reportPackageCode, reportVersionCode],
  );

  const hardFilter = useMemo(() => reportFilters as Filter[][], [reportFilters]);

  const [title, onChangeTable] = useTableTitleWithCount(pagesParam.at(-1)?.title ?? '');

  if (!columns5level.resource) return null;

  return (
    <Table
      columns={columns5level.columns}
      tableTitle={title}
      tableName={TABLE_NAME}
      resource={columns5level.resource}
      hardFilter={hardFilter}
      externalFetchXLSX={getExcelWithAudit(`Экспорт отчёта ${pagesParam.at(-1)?.title ?? ''}`, {
        moduleName: 'Calculator',
        serviceName: 'Controls',
        operationName: 'Download_controls',
      })}
      externalFetch={ksnmTableStore.externalFetch}
      onTableChange={onChangeTable}
      showAggregateRow
    />
  );
});
